// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

/**
 * Firebase configuration loaded entirely from environment variables.
 * NEVER hardcode these values here — keep them in your .env file.
 *
 * Required .env variables:
 *   REACT_APP_FIREBASE_API_KEY
 *   REACT_APP_FIREBASE_AUTH_DOMAIN
 *   REACT_APP_FIREBASE_PROJECT_ID
 *   REACT_APP_FIREBASE_STORAGE_BUCKET
 *   REACT_APP_FIREBASE_MESSAGING_SENDER_ID
 *   REACT_APP_FIREBASE_APP_ID
 *   REACT_APP_FIREBASE_MEASUREMENT_ID
 */
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Validate that all required config values are present
const missingVars = Object.entries(firebaseConfig)
    .filter(([, val]) => !val)
    .map(([key]) => key);

if (missingVars.length > 0) {
    console.error(
        `[Firebase] Missing required environment variables: ${missingVars.join(", ")}. ` +
        `Ensure your .env file is correctly configured.`
    );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Analytics is only initialized in browser environments (not SSR/Node)
let analytics = null;
if (typeof window !== "undefined") {
    try {
        analytics = getAnalytics(app);
    } catch {
        // Analytics may fail in some environments (e.g., ad blockers, incognito)
        console.warn("[Firebase] Analytics could not be initialized.");
    }
}

export { db, analytics };
